var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHealthLinearGradient = function SvgHealthLinearGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.444 1.902 7.872.074a1.09 1.09 0 0 0-.788 0L2.513 1.902a1.055 1.055 0 0 0-.661.985v1.751a11.253 11.253 0 0 0 4.571 9.024c.303.22.667.338 1.041.338.384.006.76-.112 1.07-.338a11.253 11.253 0 0 0 4.585-9.052V2.86a1.055 1.055 0 0 0-.675-.957Zm-.042 2.736a10.55 10.55 0 0 1-4.298 8.483 1.055 1.055 0 0 1-1.252 0 10.551 10.551 0 0 1-4.297-8.483V2.887a.352.352 0 0 1 .218-.33L7.345.726a.352.352 0 0 1 .267 0l4.572 1.83a.351.351 0 0 1 .218.33v1.751Z",
    fill: "url(#HealthLinearGradient_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.642 4.872H8.883V3.113a.352.352 0 0 0-.351-.351h-2.11a.352.352 0 0 0-.352.351v1.759H4.312a.352.352 0 0 0-.352.351v2.11a.352.352 0 0 0 .352.352H6.07v1.758a.352.352 0 0 0 .352.352h2.11a.352.352 0 0 0 .351-.352V7.685h1.759a.352.352 0 0 0 .351-.352v-2.11a.351.351 0 0 0-.351-.351Zm-.352 2.11H8.532a.352.352 0 0 0-.352.351v1.759H6.773V7.333a.352.352 0 0 0-.351-.351H4.663V5.575h1.759a.352.352 0 0 0 .351-.352V3.465H8.18v1.758a.352.352 0 0 0 .352.352h1.758v1.407Z",
    fill: "url(#HealthLinearGradient_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthLinearGradient_svg__a",
    x1: 1.852,
    y1: 7,
    x2: 13.119,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HealthLinearGradient_svg__b",
    x1: 3.96,
    y1: 6.278,
    x2: 10.993,
    y2: 6.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#03C8B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    stopColor: "#5C7AFF"
  })))));
};

export default SvgHealthLinearGradient;